/**
 * @generated SignedSource<<5b7fa4a9348a001bae339542f5c2e864>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AIAssetLibrarySortBy = "CREATED_DATE" | "NAME";
export type SortDirection = "ASC" | "DESC";
export type assetPickerDialogAssetsRootQuery$variables = {
  assetType?: string | null;
  categoryID?: number | null;
  sortBy?: AIAssetLibrarySortBy | null;
  sortDirection?: SortDirection | null;
};
export type assetPickerDialogAssetsRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"assetPickerDialogAssets_query">;
};
export type assetPickerDialogAssetsRootQuery = {
  response: assetPickerDialogAssetsRootQuery$data;
  variables: assetPickerDialogAssetsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v4 = {
  "kind": "Variable",
  "name": "assetType",
  "variableName": "assetType"
},
v5 = {
  "kind": "Variable",
  "name": "categoryID",
  "variableName": "categoryID"
},
v6 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v7 = {
  "kind": "Variable",
  "name": "sortDirection",
  "variableName": "sortDirection"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "assetPickerDialogAssetsRootQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "assetPickerDialogAssets_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "assetPickerDialogAssetsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "AiAssetLibraryAssetsConnection",
        "kind": "LinkedField",
        "name": "aiAssetLibraryAssets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiAssetLibraryAssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AIAssetLibraryAssetDTO",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "filters": [
          "categoryID",
          "assetType",
          "sortBy",
          "sortDirection"
        ],
        "handle": "connection",
        "key": "assetPickerDialog_aiAssetLibraryAssets",
        "kind": "LinkedHandle",
        "name": "aiAssetLibraryAssets"
      }
    ]
  },
  "params": {
    "cacheID": "f43e4c908d92b60674daa5e62f5d537b",
    "id": null,
    "metadata": {},
    "name": "assetPickerDialogAssetsRootQuery",
    "operationKind": "query",
    "text": "query assetPickerDialogAssetsRootQuery(\n  $categoryID: Int\n  $assetType: String\n  $sortBy: AIAssetLibrarySortBy\n  $sortDirection: SortDirection\n) {\n  ...assetPickerDialogAssets_query_rtDpu\n}\n\nfragment assetPickerDialogAssets_query_rtDpu on Query {\n  aiAssetLibraryAssets(first: 50, categoryID: $categoryID, assetType: $assetType, sortBy: $sortBy, sortDirection: $sortDirection) {\n    edges {\n      node {\n        id\n        name\n        fileUrl\n        thumbnailUrl\n        categoryName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a05f96de4f3df474e2e5fc0c6ce28c63";

export default node;
